// eslint-disable-next-line max-lines-per-function
define(function (require, exports, module) {
    const $ = require('jquery');
    const { megabytesToNDigits, bytesToNDigits } = require('@mail/cross-sizes-utils');
    const api = require('Cloud/Application/api');
    const _ = require('Cloud/Application/_');
    const app = require('Cloud/Application/app');
    const config = require('Cloud/config');
    const path = require('ramda').path;
    const { logger } = require('lib/logger');
    const throttle = require('lodash.throttle');
    const { store: reduxStore } = require('reactApp/store');
    const { setUser } = require('reactApp/modules/user/user.actions');
    const { clone } = require('ramda');
    const { sendTmrGoal } = require('reactApp/utils/tmr');
    const { agreeUpdateLicenseRequest } = require('reactApp/modules/profile/profile.module');
    const { getCurrentStorage } = require('reactApp/modules/router/router.selectors');

    const { captureMessage } = require('@sentry/browser');
    const login = require('Cloud/ui/Login')();
    const { noop } = require('reactApp/utils/helpers');

    const updateReduxUser = (user) => {
        reduxStore.dispatch(setUser(clone(user)));
    };

    // eslint-disable-next-line max-lines-per-function
    const user = function () {
        let user = config.get('user') || {};
        const IS_PHONE_BROWSER = app.browser.isPhone();
        const IS_WEBVIEW = config.get('IS_WEBVIEW');
        const DEFAULT_FILE_SIZE_LIMIT = 2147483648;

        const _updateSpace = throttle(function () {
            api.user.space().done(function (space) {
                app.user.updateSpace(space);
            });
        }, 500);

        function setUserParam(name, value) {
            const parts = name.split('.');
            let hash = user;

            for (let i = 0; i < parts.length - 1; i++) {
                if (hash[parts[i]] === undefined) {
                    hash[parts[i]] = {};
                }

                hash = hash[parts[i]];
            }

            hash[parts[parts.length - 1]] = value;

            // сохранение настроек на сервере
            // для авторизованных пользователей
            if (app.user.isAuthorized()) {
                api.user
                    .edit({
                        ui: user.ui,
                    })
                    .fail(function (errors) {
                        captureMessage('USER SET', {
                            arguments: errors,
                        });
                    });
            }
        }

        function getUserParam(name, defaultValue) {
            const parts = name.split('.');
            let hash = user;

            if (hash) {
                for (const element of parts) {
                    if (!hash || hash[element] === undefined) {
                        return defaultValue || null;
                    }

                    hash = hash[element];
                }
            }

            return hash;
        }

        Object.assign(app, {
            sendAgreement(suffix = '') {
                sendTmrGoal({ goal: 'agree-la' });
                const storage = getCurrentStorage(reduxStore.getState());

                return RADAR.deferred(
                    `app_send_agreement_${suffix}${storage}`,
                    api.user['agree-la']().done(function () {
                        app.user.setParam('newbie', false);
                        reduxStore.dispatch(agreeUpdateLicenseRequest());
                    })
                );
            },

            user: {
                getDomain() {
                    return user.domain;
                },

                getEmail() {
                    if (user.login && user.domain) {
                        return `${user.login}@${user.domain}`;
                    }
                },

                getFileSizeLimit(gb) {
                    if (gb) {
                        return Math.floor((app.user.getParam('cloud.file_size_limit') || DEFAULT_FILE_SIZE_LIMIT) / 1073741824);
                    }
                    return app.user.getParam('cloud.file_size_limit') || DEFAULT_FILE_SIZE_LIMIT;
                },

                destroy() {
                    user = {};
                },

                isAuthorized() {
                    return user && !!user.login && user.login.length > 0;
                },

                isCorp() {
                    return config.get('CORP_USER');
                },

                isB2BUserCorp() {
                    return config.get('B2B_BIZ_USER');
                },

                isBizUser() {
                    return config.get('BIZ_USER');
                },

                isOldBizUser() {
                    return config.get('OLD_BIZ_USER');
                },

                isNewbie() {
                    return app.user.isAuthorized() && app.user.getParam('newbie');
                },

                isSocialUser() {
                    return config.get('SOCIAL_USER');
                },

                isFrozen() {
                    return config.get('user.cloud.frozen') || config.get('user.cloudflags.FROZEN');
                },

                isVerifiedAccount() {
                    return config.get('user.account_verified');
                },

                isPaidUser() {
                    let paid = false;

                    if (user && path(['cloud', 'billing', 'enabled'], user)) {
                        const baseQuota = Number(this.getBaseQuota());
                        const fileSizeLimit = this.getFileSizeLimit();
                        const bytesTotal = Number(user.cloud.space.bytes_total);

                        if (user.PAID_ACCOUNT) {
                            paid = true;
                        } else if (baseQuota || fileSizeLimit) {
                            paid = (baseQuota && baseQuota !== bytesTotal) || fileSizeLimit !== DEFAULT_FILE_SIZE_LIMIT;
                        } else {
                            paid =
                                (user.cloud.billing.active_rate_id && user.cloud.billing.active_rate_id !== 'ZERO') ||
                                (user.cloud.billing.subscription && user.cloud.billing.subscription.length);
                        }
                    }

                    return !!paid;
                },

                isUserFreeTb() {
                    return !!config.get('IS_USER_FREE_TB');
                },

                getBaseQuota() {
                    return user && user.cloud.billing.basequota;
                },

                defrost() {
                    return new Promise((resolve, reject) => {
                        if (this.isFrozen()) {
                            api.user
                                .unfreeze()
                                .done(() => {
                                    resolve();
                                })

                                .fail((errors) => {
                                    reject(errors);
                                });
                        } else {
                            resolve();
                        }
                    }).then(() => {
                        // return new Promise((resolve, reject) => {
                        //     this.updateUserData().done(resolve).fail(reject);
                        // });
                        window.location.reload();
                    });
                },

                setParam: setUserParam,
                getParam: getUserParam,

                allUIParams() {
                    return $.extend({}, user.ui);
                },

                isUploadAllowed() {
                    return app.user.isAuthorized() && !this.isOverquota();
                },

                isOverquota() {
                    const userCloud = user.cloud;

                    if (!userCloud || !userCloud.space) {
                        return false; // actually, we don't know
                    }

                    if ('overquota' in userCloud.space) {
                        return userCloud.space.overquota;
                    }
                    return userCloud.space.used >= userCloud.space.total;
                },

                updateBilling(billing) {
                    if (!billing) {
                        RADAR('app_update-billing-empty');
                        return;
                    }

                    const costDiff = user.cloud.billing.active_cost_id !== billing.active_cost_id;
                    const rateDiff = user.cloud.billing.active_rate_id !== billing.active_rate_id;
                    const expiresDiff = user.cloud.billing.expires !== billing.expires;

                    user.cloud.billing = billing || {};
                    billing.subscription = billing.subscription || [];

                    const storage = getCurrentStorage(reduxStore.getState());

                    if (costDiff) {
                        RADAR(`app_update-billing-cost_${storage}`);
                    }

                    if (rateDiff) {
                        RADAR(`app_update-billing-rate_${storage}`);
                    }

                    if (expiresDiff) {
                        RADAR(`app_update-billing-expires_${storage}`);
                    }
                },

                updateSpace(space, doUpdate) {
                    if (!this.isAuthorized()) {
                        return;
                    }

                    const exists = path(['cloudflags', 'exists'], user) || path(['cloudflags', 'EXISTS'], user);

                    if (exists !== true) {
                        return;
                    }

                    if (!space) {
                        _updateSpace();
                        return;
                    }

                    const diffUsed = user.cloud.space.bytes_used !== space.bytes_used;
                    const diffTotal = user.cloud.space.bytes_total !== space.bytes_total;
                    const diffOverquota = user.cloud.space.overquota !== space.overquota;
                    const storage = getCurrentStorage(reduxStore.getState());

                    // юзер залил/удалил какие то файлы
                    if (diffUsed) {
                        RADAR(`app_update-space-used_${storage}`);
                        user.cloud.space.used = space.used;
                    }

                    // у юзера скорее всего изменились бонусы
                    if (diffTotal) {
                        RADAR(`app_update-space-total_${storage}`);
                        user.cloud.space.total = space.total;
                    }

                    // облако пользователя переполнилось или вышло из режима переполнения
                    if (diffOverquota) {
                        RADAR(`app_update-space-overquota_${storage}`);
                        user.cloud.space.overquota = space.overquota;
                    }

                    if (doUpdate !== false && (diffUsed || diffTotal || diffOverquota)) {
                        this.updateUserData();
                    }
                },

                formatSpaceInBytes(space) {
                    return bytesToNDigits(space, 3);
                },

                formatSpaceFloor(space) {
                    return megabytesToNDigits(space, 3, false);
                },

                formatSpaceInBytesFloor(space) {
                    return bytesToNDigits(space, 3, false);
                },

                getSpace() {
                    const original = app.user.getParam('cloud.space');
                    const space = {};
                    const MB = 1024 * 1024;

                    if (!original) {
                        space.bytesTotal = 0;
                        space.bytesUsed = 0;
                    } else {
                        space.bytesTotal = 'bytes_total' in original ? original.bytes_total : original.total * MB;
                        space.bytesUsed = 'bytes_used' in original ? original.bytes_used : original.used * MB;
                    }

                    space.bytesOver = Math.max(0, space.bytesUsed - space.bytesTotal);
                    space.bytesFree = Math.max(0, space.bytesTotal - space.bytesUsed);

                    space.total = space.bytesTotal / MB;
                    space.used = space.bytesUsed / MB;

                    const total = this.formatSpaceInBytes(space.bytesTotal);
                    const used = this.formatSpaceInBytes(space.bytesUsed);
                    const over = this.formatSpaceInBytes(space.bytesUsed >= space.bytesTotal ? space.bytesUsed - space.bytesTotal : 0);
                    const free = this.formatSpaceInBytesFloor(space.bytesTotal >= space.bytesUsed ? space.bytesTotal - space.bytesUsed : 0);

                    space.total = total.space;
                    space.used = used.space;
                    space.free = free.space;
                    space.over = over.space;
                    space.units = {
                        total: total.units,
                        used: used.units,
                        free: free.units,
                        over: over.units,
                    };

                    space.isMax = total.original >= over.original;
                    space.isFull = app.user.isOverquota();

                    // eslint-disable-next-line eqeqeq
                    space.percent = space.used == 0 ? 0 : Math.max(1, Math.round((used.original / total.original) * 100));
                    space.percentUsed = space.percent;
                    space.percentFree = 100 - space.percent;

                    space.closeToMax = (free.units === 'ГБ' && free.space <= 2) || free.units === 'МБ';

                    return space;
                },

                updateUserData() {
                    return RADAR.deferred(
                        `app_update-user_data`,
                        api
                            .user()
                            .done((data) => {
                                updateReduxUser(data);
                                this.updateSpace(data.cloud.space, false);
                                this.updateBilling(data.cloud.billing);

                                user = data;
                                user.email = app.user.getEmail();
                                config.set('user', user);

                                // нужно поправить это дело в перляке
                                if (config.get('B2B_BIZ_USER')) {
                                    app.user.setParam('newbie', false);
                                }
                            })

                            .fail(function (errors) {
                                captureMessage('UPDATE USER', {
                                    arguments: errors,
                                });
                            })
                    );
                },
            },
        });

        function reloadPage() {
            logger.verbose('AUTH CHANGE');

            RADAR.beaconImmediate('auth_change').after(function () {
                if (app.isPublic() || /^(\/promo)|(\/quota)\/?$/.test(window.location.href)) {
                    window.location.reload();
                } else if (/^\/integration/.test(window.location.pathname)) {
                    // рефрешим страницу, переходя в хомяк и (!) сохраняя гет-параметры
                    window.location.pathname = '/integration/';
                } else {
                    window.location.href = '/home/';
                }
            });
        }

        function authPopup() {
            window.__PH?.loadAccountsList(function (data) {
                const params = {
                    formType: data.accounts && data.accounts.length ? 'restore' : 'relogin',
                };

                if (user.login && user.domain) {
                    params.login = user.login;
                    params.domain = user.domain;
                }

                app.user.destroy();

                login.show(params);
            });
        }

        function authPopupHide() {
            user = config.get('user');

            app.user
                .updateUserData()
                .then(() => {
                    RADAR.beaconImmediate('auth_relogin').after(function () {
                        login.hide();
                    });
                })
                .fail(() => {
                    reloadPage();
                });
        }

        let prevEmail;

        if (window.__PH) {
            // текущий пользователь разлогинился
            window.__PH.on('authLost', function () {
                if (!prevEmail) {
                    prevEmail = app.user.getEmail(false);

                    RADAR('auth_lost');
                    authPopup();
                }
            });

            // слушаем обновления авторизации
            window.__PH.on('update', function (e, next = noop) {
                const newEmail = e?.data?.email || null;

                if (prevEmail && newEmail === prevEmail) {
                    // relogin
                    prevEmail = undefined;

                    authPopupHide();
                }

                next();
            });

            // юзер хочет войти под другим именем
            window.__PH.on('loginRequest', function (e, next = noop) {
                RADAR('auth_login-request');
                const { protocol, hostname } = window.location;

                login.show({
                    closable: true,
                    successPage: `${protocol}//${hostname}/home/`,
                });

                next();
            });

            // юзер авторизовался под другим именем
            window.__PH.on('authChange', function (e, next = noop) {
                const newEmail = e?.data?.email || null;

                if (newEmail === app.user.getEmail()) {
                    RADAR('auth_change-same');
                } else if (newEmail) {
                    reloadPage();
                } else {
                    RADAR('auth_lost');
                    authPopup();
                }

                next();
            });
        } else if (!IS_PHONE_BROWSER && !IS_WEBVIEW) {
            // there is no __PH for mobile phone for now
            RADAR.error('__PH');
            captureMessage('NO __PH');
        }

        api.on('accessDenied', function (e, from) {
            captureMessage(`ACCESS DENIED FROM ${from.toUpperCase()}`);

            RADAR(`auth_lost-${from}${window.__PH ? '' : '-no_ph'}`);
            authPopup();
        });
    };

    module.exports = user;

    return user;
});
